__turbopack_context__.v({
  "arrow": "Default-module__N_j4RG__arrow",
  "currentPage": "Default-module__N_j4RG__currentPage",
  "ellipsis": "Default-module__N_j4RG__ellipsis",
  "itemNumber": "Default-module__N_j4RG__itemNumber",
  "pagination": "Default-module__N_j4RG__pagination",
  "slash": "Default-module__N_j4RG__slash",
});
